<template>
  <div class="run-game">
    <Transition name="scale-transition">
      <div
        v-if="!playing && showTutorialOverlay && !winnerForm && !gameOverText"
        class="tutorial-overlay"
      >
        <div class="tutorial-content" elevation="5">
          <img :src="require('@/assets/images/game/logo.gif')" class="logo" />
          <h4 class="tutorial-title ma-4">بازی کن، جایزه بگیر.</h4>

          <!-- <div class="tutorial-marquee-wrapper"> -->
          <!-- <div class="marquee-track">
              <div class="marquee-item hot-item">
                <div class="marquee-item_level1">
                  <div class="marquee-item_level2"> -->
          <!-- <span>آب داغ: خطر!</span>
                  </div> -->
          <p class="tutorial-text mx-2">
            <img
              :src="require('@/assets/images/game/hot.gif')"
              class="gif-logo"
            />
            آب <span class="hot">گرم</span> خطرناکه! جاخالی بده<br />
          </p>
          <!-- </div>
              </div> -->

          <!-- <div class="marquee-item cool-item">
                <div class="marquee-item_level1">
                  <div class="marquee-item_level2"> -->
          <!-- <span>آب سرد: امتیاز!</span>
                  </div> -->
          <p class="tutorial-text mx-2">
            <img
              :src="require('@/assets/images/game/cool.gif')"
              class="gif-logo"
            />
            آب <span class="cold">سرد</span> عالیه! جمعش کن<br />
          </p>
          <!-- </div>
              </div> -->

          <!-- </div> -->
          <!-- </div> -->

          <p class="tutorial-text mt-4">
            دکمه‌ها یا لمس صفحه را بزن، لباس را جابجا کن و امتیاز بگیر!
          </p>

          <v-btn
            large
            class="btn-get-code rounded-lg mt-2"
            @click="startTutorial"
          >
            فهمیدم – شروع ماجراجویی!
          </v-btn>
        </div>
      </div>
    </Transition>
    <Transition name="scale-transition">
      <div v-if="winnerForm || gameOverText" class="winner-form-overlay">
        <div class="winner-form" elevation="5">
          <img :src="require('@/assets/images/game/logo.gif')" class="logo" />
          <h2 v-if="winnerForm" style="color: green">تبریک! شما برنده شدید!</h2>
          <h2 v-else style="color: #d81b60">بازی تمام شد</h2>
          <p>
            امتیاز نهایی شما: <strong>{{ score }}</strong>
          </p>

          <div v-if="phoneNumber && !changingPhone" class="ma-4">
            <p>شماره ثبت شده: {{ phoneNumber }}</p>
            <v-btn color="success" class="ma-1 rounded-lg" @click="submitPhone"
              >ثبت امتیاز و جایزه</v-btn
            >
            <v-btn
              color="blue-grey lighten-4"
              class="ma-1 rounded-lg"
              @click="changingPhone = true"
              >تغییر شماره</v-btn
            >
          </div>
          <div v-else class="ma-4">
            <v-text-field
              v-model="phoneNumber"
              label="شماره موبایل (۰۹xxxxxxxxx)"
              placeholder="09123456789"
              type="tel"
              inputmode="numeric"
              pattern="[0-9]*"
              maxlength="11"
              outlined
              dense
              :rules="phoneRules"
              :error-messages="phoneError ? [phoneError] : []"
              @keypress="onlyAllowDigits($event)"
              @input="validatePhoneFormat"
              autofocus
            ></v-text-field>
            <v-btn
              color="primary"
              class="rounded-lg w-100 btn-get-code"
              :disabled="!isValidPhone || submitting"
              @click="submitPhone"
              >ذخیره و ارسال امتیاز</v-btn
            >
          </div>

          <v-divider class="my-4"></v-divider>

          <div class="d-flex flex-column gap-2">
            <v-btn
              elevation="5"
              class="white--text mb-2 rounded-lg btn-get-code"
              @click="restartGame"
            >
              دوباره بازی
            </v-btn>
            <v-btn
              elevation="5"
              class="white--text rounded-lg btn-get-code"
              @click="closeGame"
            >
              بعداً بازی می‌کنم
            </v-btn>
          </div>
        </div>
      </div>
    </Transition>
    <div class="game-screen" @touchstart.prevent="handleTouch" tabindex="0">
      <div class="clothes-line"></div>
      <div class="timer" v-if="playing">
        {{ formatTime(timeLeft) }}
      </div>
      <div
        class="character"
        :class="characterState"
        :style="{ left: position + '%' }"
      >
        <img :src="characterImage" alt="لباس" />
      </div>

      <div
        v-for="obs in obstacles"
        :key="obs.id"
        class="obstacle"
        :style="{ left: obs.left + '%', top: obs.top + '%' }"
      >
        <img src="@/assets/images/game/hot.gif" alt="داغ" />
      </div>

      <div
        v-for="coin in coins"
        :key="coin.id"
        class="coin"
        :style="{ left: coin.left + '%', top: coin.top + '%' }"
      >
        <img src="@/assets/images/game/cool.gif" alt="سرد" />
      </div>
    </div>

    <div class="score-board">
      امتیاز:
      <div class="score-board-current">
        <strong class="pl-2">{{ score }}</strong>
      </div>
      جان:
      <div class="lives-hearts">
        <img
          v-for="i in 3"
          :key="i"
          :src="i <= lives ? heartFull : heartEmpty"
          alt="جان"
          class="heart-icon"
        />
      </div>
    </div>

    <div class="controls" v-if="playing && !gameOverText && !winnerForm">
      <v-btn @click="moveRight" class="btn-control">
        <img src="@/assets/images/game/right.webp" alt="راست" class="btn-dir" />
      </v-btn>
      <v-btn @click="moveLeft" class="btn-control">
        <img src="@/assets/images/game/left.webp" alt="چپ" class="btn-dir" />
      </v-btn>
    </div>
    <div
      v-if="!playing && !gameOverText && !winnerForm"
      class="start-screen-buttons"
    >
      <v-btn
        v-if="!playing && !gameOverText && !winnerForm"
        class="start-btn"
        @click="startGame"
      >
        <img
          src="@/assets/images/game/start.webp"
          alt="شروع بازی"
          class="btn-image"
        />
      </v-btn>
      <v-btn class="help-btn" @click="showHelp">
        <!-- <img src="@/assets/images/game/help.webp" alt="راهنما" class="btn-image" /> -->
        <v-icon lang>mdi-help-circle</v-icon>
        راهنما
      </v-btn>
    </div>

    <div v-if="gameOverText" class="game-over-container">
      <img
        :src="require('@/assets/images/game/sepid5_1.webp')"
        alt="سپید+"
        class="game-over-image"
      />
      <p class="game-over">{{ gameOverText }}</p>
      <v-btn
        class="restart-btn btn-get-code rounded-lg w-50"
        @click="restartGame"
      >
        بازی مجدد
      </v-btn>
    </div>

    <v-btn class="sound-toggle" @click="toggleSound">
      <img :src="soundMuted ? soundOffIcon : soundOnIcon" alt="صدا" />
    </v-btn>

    <div v-if="toastMessage" class="toast">{{ toastMessage }}</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      audioHappy: new Audio("@/assets/images/game/happy_ok.mp3"),
      audioSad: new Audio("@/assets/images/game/sad_ok.mp3"),
      audioNormal: new Audio("@/assets/images/game/normal_ok.mp3"),

      difficultyInterval: null,
      obstacleInterval: null,
      coinInterval: null,
      difficulty: 3,
      showTutorialOverlay: true,
      tutorialStep: 0,
      timeLeft: 45,
      timerInterval: null,
      position: 50,
      score: 0,
      lives: 3,
      playing: false,
      obstacles: [],
      coins: [],
      gameLoop: null,
      gameOverText: "",
      winnerForm: false,
      changingPhone: false,
      characterState: "normal",
      stateTimer: null,
      soundMuted: false,
      heartFull: require("@/assets/images/game/heart.webp"),
      heartEmpty: require("@/assets/images/game/heart_empty.webp"),
      soundOnIcon: require("@/assets/images/game/sound_on.webp"),
      soundOffIcon: require("@/assets/images/game/sound_off.webp"),
      toastMessage: "",
      toastTimeout: null,
      submitting: false,
      phoneNumber: localStorage.getItem("gamePhone") || "",
      phoneError: "",
    };
  },
  computed: {
    characterImage() {
      const resetCache = `?t=${Date.now()}`;
      if (this.characterState === "happy")
        return require("@/assets/images/game/shirt_happy.gif") + resetCache;
      if (this.characterState === "sad")
        return require("@/assets/images/game/shirt_sad.gif") + resetCache;
      return require("@/assets/images/game/shirt_d.gif");
    },
    phoneRules() {
      return [
        (v) => !!v || "شماره موبایل الزامی است",
        (v) => (v && v.length === 11) || "شماره باید دقیقاً ۱۱ رقم باشد",
        (v) => (v && v.startsWith("09")) || "شماره باید با ۰۹ شروع شود",
      ];
    },

    isValidPhone() {
      return (
        this.phoneNumber &&
        this.phoneNumber.length === 11 &&
        this.phoneNumber.startsWith("09") &&
        /^\d+$/.test(this.phoneNumber)
      );
    },
  },
  created() {
    [this.audioHappy, this.audioSad, this.audioNormal].forEach((audio) => {
      audio.load();
    });
    this.audioNormal.loop = true;
    const savedPhone = localStorage.getItem("gamePhone");
    if (savedPhone) this.phoneNumber = savedPhone;
  },
  methods: {
    onlyAllowDigits(event) {
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode < 48 || charCode > 57) {
        event.preventDefault();
      }
    },

    validatePhoneFormat() {
      this.phoneNumber = this.phoneNumber.replace(/[^0-9]/g, "");
      if (this.phoneNumber.length > 11) {
        this.phoneNumber = this.phoneNumber.substring(0, 11);
      }
      this.phoneError = "";
      if (
        this.phoneNumber.length === 11 &&
        !this.phoneNumber.startsWith("09")
      ) {
        this.phoneError = "شماره باید با ۰۹ شروع شود";
      }
    },
    closeGame() {
      this.playing = false;
      this.winnerForm = false;
      this.gameOverText = "";
      [this.audioHappy, this.audioSad, this.audioNormal].forEach((a) => {
        a.pause();
        a.currentTime = 0;
      });
      this.showTutorialOverlay = true;
      this.$emit("close");
    },
    showHelp() {
      this.showTutorialOverlay = true;
      this.tutorialStep = 0;
    },
    formatTime(seconds) {
      const mins = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${mins.toString().padStart(2, "0")}:${secs
        .toString()
        .padStart(2, "0")}`;
    },

    playSound(audio) {
      if (this.soundMuted || !audio) return;

      if (!this.soundMuted && audio) {
        [this.audioHappy, this.audioSad, this.audioNormal].forEach((a) => {
          a.pause();
          a.currentTime = 0;
        });

        audio.play().catch(() => {
          console.log("پخش صدا توسط مرورگر مسدود شد؛ نیاز به تعامل کاربر است.");
        });
      }
    },

    startTutorial() {
      this.showTutorialOverlay = false;
      localStorage.setItem("tutorial_seen", "true");
    },

    startGame() {
      // ریست کردن تمام متغیرها
      this.difficulty = 3;
      this.timeLeft = 45;
      this.position = 50;
      this.score = 0;
      this.lives = 3;
      this.obstacles = [];
      this.coins = [];
      this.gameOverText = "";
      this.winnerForm = false;
      this.playing = true;
      this.characterState = "normal";
      if (this.stateTimer) clearTimeout(this.stateTimer);
      this.clearAllIntervals();
      this.playSound(this.audioNormal);

      this.gameLoop = setInterval(this.updateGame, 35);

      this.timerInterval = setInterval(() => {
        if (this.playing) {
          this.timeLeft--;
          if (this.timeLeft <= 0) this.endGame();
        }
      }, 1000);

      this.difficultyInterval = setInterval(() => {
        if (this.playing) this.difficulty += 0.12;
      }, 10000);

      // تولید موانع (آب داغ)
      this.obstacleInterval = setInterval(() => {
        if (this.playing) this.spawnObstacle();
      }, 3000 / this.difficulty);

      // تولید سکه‌ها (آب سرد)
      this.coinInterval = setInterval(() => {
        if (this.playing) this.spawnCoin();
      }, 5000 / this.difficulty);

      this.showToast("بازی شروع شد! ۴۵ ثانیه فرصت دارید");
    },

    updateGame() {
      // حرکت اشیاء به پایین
      this.obstacles.forEach((o) => {
        o.top += 3.1 * 1.5;
      });
      this.coins.forEach((c) => {
        c.top += 2.5 * 1.5;
      });

      // --- مدیریت برخورد با آب داغ ---
      this.obstacles = this.obstacles.filter((o) => {
        const hit =
          Math.abs(o.left - this.position) < 10 && o.top > 75 && o.top < 95;
        if (hit) {
          this.lives--;
          if (this.stateTimer) clearTimeout(this.stateTimer);

          this.characterState = "sad";
          this.playSound(this.audioSad);
          this.vibrate(200);
          this.showToast("آخ! آب گرم!");

          this.stateTimer = setTimeout(() => {
            this.characterState = "normal";
            this.stateTimer = null;
            this.playSound(this.audioNormal);
          }, 500);

          if (this.lives <= 0) this.endGame();
          return false;
        }
        return o.top < 110;
      });

      // --- مدیریت جمع‌آوری آب سرد ---
      this.coins = this.coins.filter((c) => {
        const collected =
          Math.abs(c.left - this.position) < 10 && c.top > 75 && c.top < 95;
        if (collected) {
          this.score += 40;
          if (this.stateTimer) clearTimeout(this.stateTimer);

          this.characterState = "happy";
          this.playSound(this.audioHappy);
          this.vibrate([100, 50, 100]);
          this.showToast("عالی! آب سرد!");

          this.stateTimer = setTimeout(() => {
            this.characterState = "normal";
            this.stateTimer = null;
            this.playSound(this.audioNormal);
          }, 500);
          return false;
        }
        return c.top < 110;
      });
      this.obstacles = this.obstacles.filter((o) => o.top < 120);
      this.coins = this.coins.filter((c) => c.top < 120);
    },

    endGame() {
      this.playing = false;
      this.clearAllIntervals();
      this.audioNormal.pause();
      this.audioNormal.currentTime = 0;
      if (this.score >= 50) {
        this.winnerForm = true;
        this.gameOverText = "";
        this.playSound(this.audioHappy);
        this.showToast("تبریک! شما برنده شدید!");
        this.checkAndSubmitSavedPhone();
      } else {
        this.winnerForm = false;
        this.gameOverText = `بازی تمام شد! امتیاز: ${this.score}`;
        this.playSound(this.audioSad);
        this.showToast("زمان به پایان رسید!");
      }
      this.audioNormal.pause();
    },

    clearAllIntervals() {
      clearInterval(this.gameLoop);
      clearInterval(this.timerInterval);
      clearInterval(this.difficultyInterval);
      clearInterval(this.obstacleInterval);
      clearInterval(this.coinInterval);
    },

    spawnObstacle() {
      this.obstacles.push({
        id: Date.now() + Math.random(),
        left: Math.random() * 60 + 20,
        top: -20,
      });
    },

    spawnCoin() {
      this.coins.push({
        id: Date.now() + Math.random(),
        left: Math.random() * 60 + 20,
        top: -20,
      });
    },

    moveLeft() {
      this.position = Math.max(0, this.position - 20);
    },

    moveRight() {
      this.position = Math.min(80, this.position + 20);
    },

    handleTouch(e) {
      const touchX = e.touches[0].clientX;
      const rect = this.$el
        .querySelector(".game-screen")
        .getBoundingClientRect();
      let pos = ((touchX - rect.left) / rect.width) * 100;
      this.position = Math.max(0, Math.min(80, pos));
    },
    async submitScore(phone) {},
    checkAndSubmitSavedPhone() {
      const savedPhone = localStorage.getItem("gamePhone");
      if (savedPhone && /^09\d{9}$/.test(savedPhone)) {
        this.submitScore(savedPhone);
        this.$toast.success("شماره قبلی یافت شد – امتیاز ثبت شد!");
      } else {
        this.winnerForm = true;
      }
    },
    async submitPhone() {
      if (!this.phoneNumber) {
        this.phoneError = "شماره موبایل نامعتبر است";
        this.showToast("شماره تلفن وارد نشده است!");
        return;
      }
      this.phoneError = "";
      localStorage.setItem("gamePhone", this.phoneNumber);

      await this.submitScore(this.phoneNumber);

      this.winnerForm = false;
      this.changingPhone = false;
      this.showToast("جایزه با موفقیت ثبت شد!");
    },
    cancelChange() {
      this.changingPhone = false;
      this.phoneNumber = localStorage.getItem("gamePhone") || "";
    },

    restartGame() {
      this.winnerForm = false;
      this.gameOverText = "";
      this.changingPhone = false;
      this.phoneNumber = localStorage.getItem("gamePhone") || "";
      this.audioNormal.pause();
      this.startGame();
    },

    toggleSound() {
      this.soundMuted = !this.soundMuted;
      if (this.soundMuted) {
        [this.audioHappy, this.audioSad, this.audioNormal].forEach((a) =>
          a.pause(),
        );
      } else if (this.playing) {
        this.playSound(this.audioNormal);
      }
      this.showToast(this.soundMuted ? "صدا قطع شد" : "صدا وصل شد");
    },

    showToast(message) {
      this.toastMessage = message;
      if (this.toastTimeout) clearTimeout(this.toastTimeout);
      this.toastTimeout = setTimeout(() => (this.toastMessage = ""), 3000);
    },

    vibrate(pattern) {
      if (navigator.vibrate) navigator.vibrate(pattern);
    },
  },

  beforeDestroy() {
    clearInterval(this.gameLoop);
    clearInterval(this.timerInterval);
    if (this.stateTimer) clearTimeout(this.stateTimer);
  },
};
</script>

<style scoped>
.run-game {
  display: flex;
  flex-direction: column;
  position: relative;
  height: 95vh;
  text-align: center;
  font-family: "Vazir", system-ui, sans-serif;
  width: 95%;
  max-width: 95%;
  margin: 0 auto;
}

.character {
  position: absolute;
  bottom: 16px;
  width: 20%;
  transition: left 0.18s ease, transform 0.4s ease;
  z-index: 2;
}

.character.happy {
  transform: scale(1.12) rotate(6deg);
}

.character.sad {
  transform: scale(0.9) rotate(-8deg);
}

.character img {
  width: 100%;
  height: auto;
}

.game-over-container {
  margin-top: 20px;
  margin-bottom: 50px;
  padding-bottom: 10px;
  width: 100%;
  position: relative;
  margin-top: 20px;
}

.restart-btn {
  margin-top: 16px;
  margin-bottom: 30px;
}

.game-screen {
  position: relative;
  width: 100%;
  max-width: 420px;
  height: 40vh !important;
  margin: 0 auto;
  background: linear-gradient(to bottom, #bbdefb2c, #e3f2fd33);
  border-radius: 16px;
  overflow: hidden;
  touch-action: none;
  backdrop-filter: blur(10px);
  border: 2px solid rgb(58, 145, 58);
}

.obstacle,
.coin {
  position: absolute;
  width: 12%;
  aspect-ratio: 1 / 1;
}

.obstacle img,
.coin img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.run-game {
  display: flex;
  flex-direction: column;
  height: 100%;
  text-align: center;
  font-family: "Vazir", system-ui, sans-serif;
  width: 95%;
  max-width: 95%;
  margin: 0 auto;
}
.clothes-line {
  position: absolute;
  bottom: 70px;
  left: 0;
  width: 100%;
  height: 3px;
  background-color: #808080;
  z-index: 1;
}
.character {
  position: absolute;
  bottom: 40px;
  width: 20%;
  transition: left 0.18s ease;
  z-index: 2; /* بالای بند رخت */
}
.character img {
  width: 100%;
  height: auto;
}
.obstacle,
.coin {
  position: absolute;
  width: 12%;
  aspect-ratio: 1 / 1;
}
.obstacle img,
.coin img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.score-board {
  display: flex;
  flex-direction: row;
  gap: 2px;
  font-size: 1.1em;
  color: hsl(128, 59%, 15%);
  margin: 3px 0;
  min-height: 40px;
  padding: 2px;
  padding-bottom: 3px !important;
  justify-content: center;
  align-items: anchor-center;
  flex-wrap: wrap;
  background: rgba(255, 255, 255, 0.342);
  border-radius: 16px;
  backdrop-filter: blur(10px);
  padding-top: 0px !important;
  border: 2px solid rgb(58, 145, 58);
  max-width: 100% !important;
  min-width: 100% !important;
}
.score-board-current {
  background-image: url("~@/assets/images/game/score4.webp");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  font-size: 1em;
  color: #f8fafd;
  margin: 0;
  width: 150px;
  min-height: 50px;
  padding: 0px;
  display: flex;
  align-items: center;
  direction: ltr;
  padding-top: 8px;
  padding-left: 30px;
}
.lives-hearts {
  display: flex;
  gap: 5px;
}
.heart-icon {
  width: 25px;
  height: 25px;
}
.controls {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 1px;
  width: 100%;
  margin-bottom: 10px;
}

.game-over-image {
  z-index: 3;
  width: 200px;
}
.game-over {
  color: #d81b60;
  font-size: 1.4em;
  font-weight: bold;
  margin-top: 10px;
}
.winner-form {
  margin-top: 20px;
  padding: 20px;
  background: linear-gradient(to bottom, #e8f5e9, #1f4b20) !important;
  border-radius: 12px;
}
.sound-toggle {
  position: absolute;
  width: min-content;
  min-width: min-content;
  top: 10px;
  left: 24px;
  background: transparent;
  border: none;
  box-shadow: none;
  background: transparent !important;
  height: auto;
  border-radius: 50%;
  width: min-content;
  min-width: min-content;
  box-sizing: border-box;
  margin: 0px;
  padding: 0px;
}
.sound-toggle img {
  width: 25px;
  height: 25px;
}
.toast {
  position: fixed;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
  background: #333;
  color: #fff;
  padding: 10px 20px;
  border-radius: 8px;
  z-index: 10;
  opacity: 0.9;
}
.btn-control,
.run-game {
  /* text-align: center;
  padding: 15px;
  background: transparent;
  height: 100%;
  font-family: "Vazir", system-ui, sans-serif;
  width: 95%;
  max-width: 95%;
  margin: 0 auto;
  margin-bottom: 6px; */
  display: flex;
  flex-direction: column;
  height: 100%;
  text-align: center;
  font-family: "Vazir", system-ui, sans-serif;
  width: 95%;
  max-width: 95%;
  margin: 0 auto;
  background: transparent !important;
  justify-content: flex-start;
  align-items: flex-start;
}

.game-screen {
  position: relative;
  width: 100%;
  max-width: 420px;
  height: 550px;
  margin: 0 auto;
  background: linear-gradient(to bottom, #bbdefb2c, #e3f2fd33);
  /* border: 5px solid #0288d1; */
  border-radius: 16px;
  overflow: hidden;
  touch-action: none;
  backdrop-filter: blur(10px);
}
.character {
  position: absolute;
  bottom: 13px;
  width: 20%;
  transition: left 0.18s ease;
}
.character img {
  width: 100%;
  height: auto;
}
.obstacle,
.coin {
  position: absolute;
  width: 12%;
  aspect-ratio: 1 / 1;
}
.btn-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  max-width: 100%;
  max-height: 100%;
  width: 160px;
  height: auto;
  object-fit: contain;
  display: block;
}
.btn-dir {
  width: 100%;
  height: 100%;
  object-fit: contain;
  max-width: 100%;
  max-height: 100%;
  width: 100px;
  height: auto;
  object-fit: contain;
  display: block;
}
.btn-control .btn-dir {
  width: 125px !important;
  height: auto;
  object-fit: contain;
  display: block;
}

.start-btn .btn-image {
  width: 130px;
  height: auto;
  object-fit: contain;
  display: block;
}
.btn-control {
  padding: 12px 40px;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  font-size: 1.2em;
  transition: all 0.3s;
  padding: 0;
  min-width: unset;
  border-radius: 12px;
  background: transparent;
  border: none;
  box-shadow: none;
  width: 125px !important;
  margin-left: auto !important;
  margin-right: auto !important;
  margin-top: 1px !important;
  margin-bottom: 25px !important;
}

.obstacle img,
.coin img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.hud {
  font-size: 1.5em;
  font-weight: bold;
  color: #01579b;
  margin: 15px 0;
}

.start-btn {
  padding: 12px 40px;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  font-size: 1.2em;
  transition: all 0.3s;
  padding: 0;
  min-width: unset;
  border-radius: 12px;
  background: transparent;
  border: none;
  box-shadow: none;
  width: 125px !important;
  margin-bottom: 40px !important;
  margin-left: auto !important;
  margin-right: auto !important;
  margin-top: 10px !important;
}
.game-over {
  color: #d81b60;
  font-size: 1.4em;
  font-weight: bold;
  margin-top: 25px;
}
.score-board {
  display: flex;
  flex-direction: row;
  gap: 3px;
  font-size: 1.4em;
  color: #004aad;
  margin: 10px 0;
  min-height: 50px;
  padding: 10px;
  justify-content: center;
  flex-wrap: wrap;
}
.score-board-hearter {
  background-image: url("~@/assets/images/game/score.webp");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  width: 200px;
  font-size: 1em;
  color: #f8fafd;
  margin: 0;
  min-height: 50px;
  padding: 0px;
  display: flex;
  align-items: center;
  direction: ltr;
  padding-top: 8px;
  padding-left: 45px;
}
.score-board-current {
  background-image: url("~@/assets/images/game/score4.webp");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  font-size: 1em;
  color: #f8fafd;
  margin: 0;
  width: 150px;
  min-height: 50px;
  padding: 0px;
  display: flex;
  align-items: center;
  direction: ltr;
  padding-top: 8px;
  padding-left: 30px;
}
.controls {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.timer {
  position: absolute;
  top: 15px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 1.8em;
  font-weight: bold;
  color: #d32f2f;
  background: rgba(255, 255, 255, 0.7);
  padding: 8px 16px;
  border-radius: 12px;
  z-index: 5;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

/* اگر می‌خوای وقتی زمان کم می‌شه قرمزتر بشه */
.timer.low {
  color: #f44336;
  animation: pulse 1s infinite;
}

@keyframes pulse {
  0% {
    transform: translateX(-50%) scale(1);
  }
  50% {
    transform: translateX(-50%) scale(1.08);
  }
  100% {
    transform: translateX(-50%) scale(1);
  }
}
.tutorial-overlay {
  position: relative;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  margin-top: -90px;
}
.tutorial-content {
  background: linear-gradient(to bottom, white, rgba(178, 247, 207, 0.582));
  padding: 24px;
  border-radius: 16px;
  text-align: center;
  max-width: 90%;
  min-width: 80%;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: -50px !important;
}
.tutorial-gif {
  width: 220px;
  margin-bottom: 16px;
}
.hot {
  color: #d32f2f;
  font-weight: bold;
}
.cold {
  color: #1976d2;
  font-weight: bold;
}
.winner-form-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.637);
  z-index: 15;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.winner-form {
  background: linear-gradient(to bottom, #e8f5e9, #1f4b20);
  padding: 24px;
  border-radius: 16px;
  max-width: 90%;
  text-align: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}
.logo {
  width: 98px;
  margin-bottom: 10px;
}
.start-screen-buttons {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 5px;
  margin: 20px auto;
  flex-wrap: wrap;
}

.start-btn {
  width: 140px !important;
  height: auto;
  margin: 0 !important;
  background: transparent !important;
}

.help-btn {
  background: transparent;
  border: none;
  box-shadow: none;
  padding: 0px !important;
  width: 80px !important;
  height: 40px !important;
  border-radius: 16px !important;
  min-width: 80px;
  max-width: 80px;
  min-height: 40px !important;
  max-height: 40px !important;
  color: rgb(2, 37, 2);
  backdrop-filter: blur(10px) !important;
  border: 2px solid rgb(2, 37, 2);
  opacity: 0.7 !important;
}

.help-btn .btn-image {
  width: 80px;
  height: auto;
  object-fit: contain;
}

.help-btn {
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(4px);
  padding: 12px;
  min-width: 80px;
  min-height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-get-code {
  margin: 10px;
  border: 1px solid rgba(8, 189, 47, 1) !important;
  padding: 15px 60px;
  text-align: center;
  text-transform: uppercase;
  transition: 0.7s !important;
  font-weight: bold !important;
  background-size: 200% auto;
  color: rgba(8, 189, 47, 1) !important;
  border-radius: 5px !important;
  display: block;
  animation: pulseRing 2.2s ease-out infinite;
}

.btn-get-code:hover {
  background-image: linear-gradient(
    to right,
    rgba(8, 189, 47, 1) 0%,
    rgba(0, 245, 255, 1) 51%,
    rgba(8, 189, 47, 1) 100%
  );
  background-position: right center;
  color: #fff !important;
  text-decoration: none !important;
  border: none !important;
  transition: 0.7s !important;
  font-weight: bold !important;
  box-shadow: 0 0 20px #eee;
}
.pulseRing.delay {
  animation-delay: 1.1s;
}

@keyframes pulseRing {
  0% {
    transform: scale(0.9);
    opacity: 0.7;
    box-shadow: 0 0 10px #3258398a;
  }
  0% {
    transform: scale(0.95);
    opacity: 0.9;
    box-shadow: 0 0 20px #264e2d;
  }
  40% {
    opacity: 1;
    box-shadow: 0 0 10px #1c4123;
  }
  0% {
    transform: scale(0.95);
    opacity: 0.9;
    box-shadow: 0 0 20px #3258398a;
  }
  100% {
    transform: scale(0.9);
    opacity: 0.8;
    box-shadow: 0 0 10px #2b5032;
  }
}
/* ظرف اصلی راهنما که حرکت را محدود می‌کند */
.tutorial-marquee-wrapper {
  width: 100%;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 12px;
  padding: 15px 0;
  margin: 15px 0;
  border: 1px dashed #4caf50;
  direction: ltr; /* برای حرکت روان از چپ به راست */
}

/* مسیری که آیتم‌ها روی آن حرکت می‌کنند */
.marquee-track {
  display: flex;
  width: max-content;
  animation: marquee-loop 10s linear infinite;
}

/* استایل هر آیتم در حال حرکت */
.marquee-item {
  display: flex;
  align-items: center;
  gap: 3px;
  padding: 0 3px;
  font-weight: bold;
  white-space: nowrap;
}

.marquee-item_level1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  padding: 0 3px;
  font-weight: bold;
  white-space: nowrap;
}
.marquee-item_level2 {
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 3px;
  padding: 0 3px;
  font-weight: bold;
  white-space: nowrap;
}

.hot-item span {
  color: #d32f2f;
}
.cool-item span {
  color: #1976d2;
}

.marquee-item img {
  width: 35px;
  height: 35px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

@keyframes marquee-loop {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

.tutorial-title {
  color: #2e7d32;
  margin-bottom: 5px;
}
.tutorial-marquee-wrapper:active .marquee-track,
.tutorial-marquee-wrapper:hover .marquee-track {
  animation-play-state: paused;
}
.gif-logo {
  width: 30px;
  height: auto;
}
</style>
